<fieldset>
  <legend class="keyLabel">{{ fieldLabel() }}</legend>
  <div class="content">
    @if (response().TotalCapacity) {
      <div class="detailRow">
        <label class="displayLabel">Total Capacity:</label>
        <label class="displayValue">{{ response().TotalCapacity | number: '1.0-2' }}</label>
        <label class="unitLabel">{{ getCapacityUnits() }}</label>
      </div>
    }
    @if (!isHeat() && response().SensibleCapacity) {
      <div class="detailRow">
        <label class="displayLabel">Sensible Capacity:</label>
        <label class="displayValue">{{ response().SensibleCapacity | number: '1.0-2' }}</label>
        <label class="unitLabel">{{ getCapacityUnits() }}</label>
      </div>
    }
    <div class="detailRow">
      <label class="displayLabel">Dry Bulb:</label>
      <label class="displayValue">{{ response().LeavingDryBulbTemperature | number: '1.0-2' }}</label>
      <label class="unitLabel">{{ getTemperatureUnits() }}</label>
    </div>
    @if (!isHeat() && response().LeavingWetBulbTemperature) {
      <div class="detailRow">
        <label class="displayLabel">Wet Bulb:</label>
        <label class="displayValue">{{ response().LeavingWetBulbTemperature | number: '1.0-2' }}</label>
        <label class="unitLabel">{{ getTemperatureUnits() }}</label>
      </div>
    }
    @if (response().FluidFlowRate) {
      <div class="detailRow">
        <label class="displayLabel">Flow Rate:</label>
        <label class="displayValue">{{ response().FluidFlowRate | number: '1.0-2' }}</label>
        <label class="unitLabel">{{ getFlowRateUnits() }}</label>
      </div>
    }
    @if (response().FluidTemperatureChange) {
      <div class="detailRow">
        <label class="displayLabel">Fluid Temp Change:</label>
        <label class="displayValue">{{ response().FluidTemperatureChange | number: '1.0-2' }}</label>
        <label class="unitLabel">{{ getTemperatureUnits() }}</label>
      </div>
    }
    @if (response().LeavingFluidTemperature) {
      <div class="detailRow">
        <label class="displayLabel">Leaving Fluid Temp:</label>
        <label class="displayValue">{{ response().LeavingFluidTemperature | number: '1.0-2' }}</label>
        <label class="unitLabel">{{ getTemperatureUnits() }}</label>
      </div>
    }
    @if (!isSureflow() && response().FluidPressureDrop && 'NaN' !== response().FluidPressureDrop.toString()) {
      <div class="detailRow"
        >
        <label class="displayLabel">Fluid Pressure Drop:</label>
        <label class="displayValue">{{ response().FluidPressureDrop | number: '1.0-2' }}</label>
        <label class="unitLabel">{{ getPressureDropUnits() }}</label>
      </div>
    }
  </div>
</fieldset>
